export default __webpack_public_path__ + "static/media/ic_contact_phone.42958aa2.svg";